export default __webpack_public_path__ + "static/media/authorbg02.ab4ea37c.jpg";